import { render, staticRenderFns } from "./AdminAccountWarning.vue?vue&type=template&id=d77402d6&scoped=true&"
import script from "./AdminAccountWarning.vue?vue&type=script&lang=js&"
export * from "./AdminAccountWarning.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccountWarning.vue?vue&type=style&index=0&id=d77402d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77402d6",
  null
  
)

export default component.exports